/**
 * LEAGUE HUB — operator legal configuration.
 *
 * Fill in these placeholders before public launch. The values flow into
 * every legal page (privacy, terms, cookies, community, contact-info,
 * subscriptions, withdrawal) plus the footer disclosure.
 *
 * Why a single config: any change here propagates everywhere
 * automatically — no risk of one page showing a stale address or the
 * wrong privacy contact email.
 *
 * ⚠  This is PLACEHOLDER copy. All legal text on the site is a DRAFT
 *    intended to give your lawyer a starting structure. Do NOT treat
 *    these documents as final or as legal advice.
 *    See /app/LEGAL_SETUP.md for the launch checklist.
 */

export const LEGAL_CONFIG = {
  // ──────────────────────────────────────────────────────────────────
  // OPERATOR IDENTITY — required by PIPEDA + provincial consumer-protection rules
  // ──────────────────────────────────────────────────────────────────
  // Full legal name of the entity operating leaguehub.co.
  // Example: "Jane Smith" (sole proprietor) or "Squad Seeker Inc."
  legal_entity_name: "[OPERATOR LEGAL NAME — FILL BEFORE LAUNCH]",

  // Business address (street, city, province, postal code).
  legal_address: "[STREET ADDRESS, CITY, PROVINCE, POSTAL CODE — FILL BEFORE LAUNCH]",

  // General contact + privacy contact emails.
  contact_email:    "team@leaguehub.co",
  privacy_email:    "privacy@leaguehub.co",     // alias to team@ until provisioned
  abuse_email:      "abuse@leaguehub.co",

  // Province of operation. Drives governing law in the Terms.
  // Example: "Ontario", "Quebec", "British Columbia".
  province: "[PROVINCE — FILL BEFORE LAUNCH]",

  country: "Canada",

  // GST/HST registration number — required on invoices once you exceed
  // CA$30k/yr in taxable revenue. Leave blank until registered.
  gst_hst_number: "",

  // Marketing/contact website URL (for the legal disclosures).
  site_url: "https://leaguehub.co",

  // ──────────────────────────────────────────────────────────────────
  // DOCUMENT VERSIONS — bumped on each material change so we can
  // log "user X accepted ToS v1.0 on date Y". Used by the Phase 6
  // privacy-by-design audit log (deferred — wired up next iteration).
  // ──────────────────────────────────────────────────────────────────
  versions: {
    privacy:       "1.0",
    terms:         "1.0",
    cookies:       "1.0",
    community:     "1.0",
    subscriptions: "1.0",
    withdrawal:    "1.0",
  },
  last_updated: "2026-02-25",

  // ──────────────────────────────────────────────────────────────────
  // MINIMUM AGE — recommended 13+ per COPPA-style child-protection
  // norms. Override to 16+ for stricter EU compliance posture.
  // ──────────────────────────────────────────────────────────────────
  minimum_age: 13,

  // ──────────────────────────────────────────────────────────────────
  // PRICING (kept in sync with /pricing) — used in the subscription
  // disclosure copy near checkout CTAs.
  // ──────────────────────────────────────────────────────────────────
  pricing: {
    pro_player: { amount: "$1.99", interval: "month", currency: "USD" },
    pro_league: { amount: "$9.99", interval: "month", currency: "USD" },
  },

  // ──────────────────────────────────────────────────────────────────
  // THIRD PARTIES we name explicitly in /legal/privacy
  // ──────────────────────────────────────────────────────────────────
  processors: [
    { name: "Stripe, Inc.",          purpose: "Payment processing",            jurisdiction: "United States" },
    { name: "Google LLC",            purpose: "OAuth sign-in",                 jurisdiction: "United States" },
    { name: "Discord Inc.",          purpose: "OAuth sign-in + community link",jurisdiction: "United States" },
    { name: "Cloudflare, Inc.",      purpose: "Edge network + analytics (RUM)",jurisdiction: "United States" },
    { name: "Google Gemini",         purpose: "AI avatar generation",          jurisdiction: "United States" },
    { name: "MongoDB Atlas",         purpose: "Application database",          jurisdiction: "United States / Canada" },
  ],
};

export default LEGAL_CONFIG;
